<template>
  <div
    v-if="loading"
    class="flex h-screen items-center justify-center"
  >
    <LoaderCircle
      class="animate-spin"
      :size="100"
    />
  </div>
</template>

<script setup lang="ts">
  import { LoaderCircle } from 'lucide-vue-next'
  import { genericErrorToast } from '@/lib/toasts'
  import { computed, onMounted, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { CLIENT_PORTAL } from '@/router/routes'
  import { QuestionnaireSubmissionsService } from '@/types/generated'

  const route = useRoute()
  const router = useRouter()

  const orgQuestionnaireCreationToken = computed(
    () => route.params.org_questionnaire_creation_token as string
  )
  const questionnaireQuestionnaireCreationToken = computed(
    () => route.params.questionnaire_questionnaire_creation_token as string
  )
  const loading = ref(true)

  onMounted(async () => {
    try {
      const response =
        await QuestionnaireSubmissionsService.questionnaireSubmissionsCreateExternalCreate({
          requestBody: {
            questionnaire_creation_token: questionnaireQuestionnaireCreationToken.value,
            org_questionnaire_creation_token: orgQuestionnaireCreationToken.value
          }
        })

      if (response) {
        await router.push({
          path: CLIENT_PORTAL.EXTERNAL_QUESTIONNAIRE_DETAIL.replace(':uuid', response.short_id),
          query: { access_token: response.third_party_access_token }
        })
      } else {
        genericErrorToast()
      }
    } catch (error) {
      console.error('Error creating external questionnaire submission:', error)
      genericErrorToast()
    } finally {
      loading.value = false
    }
  })
</script>
